<header class="app-header">
  <div class="header-container">
    <div class="logo-wrapper">
      <img src="assets/images/icons/logo.svg" alt="Logo" class="logo">
    </div>
  </div>
</header>
